module.exports = __webpack_public_path__ + "img/seven_normal_box.c6ed49fa.png";